import React from 'react'

class Upload extends React.Component {
  constructor (props) {
    super(props)
    this.uploadFile = this.uploadFile.bind(this)
  }
  uploadFile () {
    fetch(
      `api/print/${this.select.value}/template/xlsx`,
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/octet-stream',
        },
        body: this.fileInput.files[0],
      },
    )
      .then((response) => (response.ok ? response : Promise.reject(response)))
      .then(() => {
        window.alert('upload done')
      }).catch((response) => {
        window.alert('upload error', response)
      })
  }
  render () {
    return (
      <div>
        <select
          ref={ref => (this.select = ref)}
        >
          <option value=""> ---- choose ---- </option>
          <option value="leaves">Leaves Template</option>
        </select>
        <br />
        <input
          ref={ref => (this.fileInput = ref)}
          type="file"
          id="upload_input"
          onChange={this.uploadFile}
        />
      </div>
    )
  }
}

export default Upload



// WEBPACK FOOTER //
// ./src/components/UploadTemplate.jsx